

// ration: 0 ~ 1
export function interp(a: number, b: number, ratio: number): number {
  return a + (b - a) * ratio;
}

/**
 * 변수가 정의 안 되어있거나 null인 경우를 확인하는 함수
 */
export function IsEmptyVar(value: any): boolean {
  return typeof value === 'undefined' || value === null;
}


/**
 * 변수가 정의 안 되어있거나 null이거나 빈 문자열인 경우를 확인하는 함수
 */
export function IsEmptyString(value: string | null | undefined): boolean {
  return IsEmptyVar(value) || value?.trim() === '';
}


/**
 * 'Y'값이면 True, 기타 값이면 False를 반환.
 * 정의가 안 되어있거나 null인 경우에도 False를 반환.
 */
export function ParseBoolean(value: string): boolean {
  return IsEmptyVar(value) ? false : value === 'Y';
}


export function Txt2Date(time: number): Date {
  return new Date(time);
}


const regExLastNum = '[1-9][0-9]*$';

/**
 * 문자열에서 마지막 숫자를 얻는 함수
 * @param value
 * @return 마지막 숫자. 없으면 0
 */
export function GetLastNumber(value: string): number {
  const match = value.match(regExLastNum);
  return match ? Number(match[0]) : 0;
}


/**
 * 문자열에 https:// 나 http:// 가 포함되었는지 확인하는 함수
 */
export function IsContainHttp(value: string): boolean {
  return /(http(s?)):\/\//i.test(value);
}


/**
 * 주소에서 서버 영역을 얻는 함수.
 */
export function GetServerFromUrl(url: string): string | null {
  const regex = /^(https?:\/\/[^\/]+)\//i;
  const match = url.match(regex);
  return match ? match[1] : null;
}


/**
 * 오브젝트 비교. 2-depth 까지 가능
 *
 * @param obj1
 * @param obj2
 * @constructor
 */
export function IsEqualObj(obj1: Record<string, any>, obj2: Record<string, any>): boolean {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }

  return true;
}

export function isEqualOrBothUndefined(a?: string, b?: string) {
  return a === b || (!a && !b);
}


/**
 * 입력한 값을 반으로 나누고 올림해서 정수로 만드는 함수
 */
export function GetCeilHalf(n: number): number {
  return Math.ceil(n / 2);
}

/**
 * 한자인지 확인하는 함수
 * 참고: https://bit.ly/2ZKZUov
 *
 * @param char - 확인하려는 1글자 문자열
 */
export function IsHanja(char: string): boolean {
  const regEx = '[\u2e80-\u2eff\u31c0-\u31ef\u3200-\u32ff\u3400-\u4dbf\u4e00-\u9fbf\uf900-\ufaff]';
  return !!char.match(regEx);
}


export function RemoveSpace(value: string): string {
  return value.replace(/\s/g, '');
}


export function SafeClearTimeout(handle: NodeJS.Timeout|null): void {
  if (handle !== null) {
    clearTimeout(handle);
  }
}


/**
 * enum 값에서 값 이름을 문자열로 받아오는 함수.
 * @param myEnum
 * @param enumValue
 */
export function getEnumNameByValue(myEnum: any, enumValue: number): string | null {
  let keys = Object.keys(myEnum).filter(x => myEnum[x] == enumValue);
  return keys.length > 0 ? keys[0] : null;
}

export function GenPassword(passwordLength: number = 12): string {
  const chars = '0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let password = '';
  for (var i = 0; i <= passwordLength; i++) {
    const randomNumber = Math.floor(Math.random() * chars.length);
    password += chars.substring(randomNumber, randomNumber +1);
  }
  return password;
}


export function CmpVersion(v1: string, v2: string): number {
  const ver2list = (v: string): Array<number> => v.split('.').map(value => parseInt(value, 10));
  const v1list = ver2list(v1);
  const v2list = ver2list(v2);
  const max = Math.max(v1list.length, v2list.length);

  for(let i = 0; max; ++i) {
    if (IsEmptyVar(v2list)) { return 1; }
    else if (IsEmptyVar(v1list)) { return -1; }

    const d = v1list[i] - v2list[i];
    if (d !== 0) { return d; }
  }
  return 0;
}


/**
 * 두 음성 파일 이름이 같은지 확인하는 함수 (확장자 무시, NFC로 정규화한 후 비교)
 * @param v1
 * @param v2
 */
export function IsEqualVoiceFile(v1: string, v2: string): boolean {
  const unescape = (str: string): string => decodeURIComponent(str);
  const normalize = (str: string): string => str.normalize('NFC');
  const removeExtension = (str: string): string => str.replace(/\.[^/.]+$/, '');
  const getFileName = (str: string): string => str.split('/').pop()?.split('\\').pop() || '';

  const processFileName = (str: string): string =>
    normalize(removeExtension(getFileName(unescape(str))));

  const fileName1 = processFileName(v1);
  const fileName2 = processFileName(v2);

  return fileName1 === fileName2;
}
